import { useTheme } from '../../store/ThemeContext';
import pt from '../../locales/pt';
import { ThemePicker } from '../../components/theme/ThemePicker';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/Card';

export function AppearanceSettingsCard() {
  const { theme, setTheme } = useTheme();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{pt.settings.appearance.cardTitle}</CardTitle>
        <CardDescription>{pt.settings.appearance.cardDesc}</CardDescription>
      </CardHeader>
      <CardContent>
        <ThemePicker current={theme} onSelect={setTheme} />
      </CardContent>
    </Card>
  );
}
